<template>
  <a
    class="ml-2 mr-2"
    data-toggle="modal"
    data-target="#resetPassModal"
    @click="$parent.$parent.$parent.resetPassFunction(data)"
    :class="options.class"
  >
    <span class="ag-tooltip" style="border:none; width: auto; min-width: auto;">
      <i class="ag-icon ag-icon_restart"></i>
      <div class="top">
        {{$t("resetPassword")}}
      </div>
    </span>
  </a>
</template>

<script>
export default {
  name: "tableResetPassComponent",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped></style>
